import type { CSSProperties } from "react";
import { cn } from "../tokens.js";

export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return <div className={cn("ui-skeleton", className)} style={style} aria-hidden />;
}
